module.exports = require("skypager-registry/lib/context");


//////////////////
// WEBPACK FOOTER
// external "skypager-registry/lib/context"
// module id = 1
// module chunks = 0